export function buildFormData(variables: Record<string, unknown>): FormData {
  const formData = new FormData();
  let fileValue: File | null = null;
  const jsonFields: Record<string, unknown> = {};
  Object.entries(variables).forEach(([key, value]) => {
    if (value instanceof File) {
      fileValue = value;
    } else {
      jsonFields[key] = value;
    }
  });
  // fileValue is only ever assigned a File (see the instanceof check above),
  // so the null guard alone is sufficient to narrow it to File.
  if (fileValue !== null) {
    formData.append('file', fileValue);
  }
  formData.append('json_data', JSON.stringify(jsonFields));
  return formData;
}
